(function () {
    'use strict';

    var module = angular.module('uwAgenda.version');
    module.factory('VersionService', ['$http', VersionServiceFn]);

    /* service for requesting version */
    function VersionServiceFn($http) {

        var baseUrl = '/api/info/version';
        var service = {
            getApiVersion: getApiVersion,
        };

        return service;

        /* get api version */
        function getApiVersion() {
            return $http.get(baseUrl).then(function (response) { return response.data; });
        }
    }
})();